import { Action, createAction, props } from '@ngrx/store';
import { ActionType, AppLanguage, CorrelationParams, createEntityActions, IDocumentFile, IFactorConfiguration, INotificationOptions, NotificationType } from '@aston/foundation';
import { AppConfiguration } from 'apps/console/src/app/app.configuration';
import { IChoiceAction, IConfirmModalContent, SalesConditionsDocument } from 'apps/console/src/app/shared-module/models';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { IAccountInformationModel } from 'apps/console/src/app/user-module/models';
const ActionPrefix = 'App';

export const Noop = createAction(`[${ActionPrefix}] Nothing To Do`);

export const NotFound = createAction(`[${ActionPrefix}] Not Found`, props<{ fromError?: Error, message?: string }>());

export const UserActions = createEntityActions<IAccountInformationModel>(ActionPrefix, 'User');
export const {
	LoadEntityRequest: LoadUserRequest,
	LoadEntitySuccess: LoadUserSuccess,
	LoadEntityFailure: LoadUserFailure,
} = UserActions;

export const ConfigActions = createEntityActions<AppConfiguration>(ActionPrefix, 'Config');
export const {
	LoadEntityRequest: LoadConfigRequest,
	LoadEntitySuccess: LoadConfigSuccess,
	LoadEntityFailure: LoadConfigFailure,
} = ConfigActions;

export const salesConditionsActions = createEntityActions<SalesConditionsDocument>(ActionPrefix, 'Sales Conditions');
export const {
	LoadEntityRequest: LoadSalesConditionsRequest,
	LoadEntitySuccess: LoadSalesConditionsSuccess,
	LoadEntityFailure: LoadSalesConditionsFailure,
} = salesConditionsActions;

export const FactorConfigActions = createEntityActions<IFactorConfiguration>(ActionPrefix, 'Factor Config');
export const {
	LoadEntityRequest: LoadFactorConfigRequest,
	LoadEntitySuccess: LoadFactorConfigSuccess,
	LoadEntityFailure: LoadFactorConfigFailure,
} = FactorConfigActions;

export const userLanguageActions = createEntityActions<{ language: string }>(ActionPrefix, 'User Language');
export const {
	UpdateEntityRequest: SetUserLanguageRequest,
	UpdateEntitySuccess: SetUserLanguageSuccess,
	UpdateEntityFailure: SetUserLanguageFailure
} = userLanguageActions;

export const UpdateConfigRequest = createAction(`[${ActionPrefix}] Update Config Request`);
export const UpdateConfigSuccess = createAction(
	`[${ActionPrefix}] Update Config Success`,
	props<{ config: AppConfiguration }>()
);

export const LoadValidatorsRequest = createAction(`[${ActionPrefix}] Load Validators Request`);
export const LoadValidatorsSuccess = createAction(`[${ActionPrefix}] Load Validators Success`);

export const Login = createAction(`[${ActionPrefix}] Login`);
export const Logout = createAction(`[${ActionPrefix}] Logout`);

export const Navigate = createAction(`[${ActionPrefix}] Navigate To`, props<{ to: any[] }>());
export const NavigateBack = createAction(`[${ActionPrefix}] Navigate back`);

export const StartInitializer = createAction(`[${ActionPrefix}] Start Initializer`);
export const FinishInitializer = createAction(`[${ActionPrefix}] Finish Initializer`);
export const CriticalFailure = createAction(`[${ActionPrefix}] Critical Failure`, props<{ error: Error }>());

export const StartScrollToTop = createAction(
	`[${ActionPrefix}] Scroll to top start`,
	(element?: string) => ({ element })
);

export const FinishScrollToTop = createAction(`[${ActionPrefix}] Scroll to top finish`);

export const ErrorLog = createAction(
	`[${ActionPrefix}] Error`,
	(message: string | Error, data?: any) => ({
		message,
		data,
		error: message instanceof Error ? message : new Error(message)
	})
);

export const InfoLog = createAction(
	`[${ActionPrefix}] Info`,
	props<{ message: string, data?: any }>()
);

export const OpenChoicesModal = createAction(
	`[${ActionPrefix}] Choices Modal Open`, (
		content: IConfirmModalContent,
		correlationParams?: CorrelationParams,
		...choices: IChoiceAction[]
	) => ({
		content,
		choices,
		options: { size: 'lg', centered: true } as NgbModalOptions,
		correlationParams
	})
);

export const OpenConfirmationModal = createAction(
	`[${ActionPrefix}] Modal Open`, (
		content: IConfirmModalContent, confirmationAction?: Action | Action[], cancelAction?: Action | Action[],
		correlationParams?: CorrelationParams) => ({
		content,
		confirmationAction,
		cancelAction,
		correlationParams,
		options: { size: 'lg', centered: true } as NgbModalOptions
	})
);
export const CloseConfirmationModal = createAction(
	`[${ActionPrefix}] Modal Closed`,
	props<{ actionType: ActionType, correlationParams?: CorrelationParams }>()
);

export const ToastReset = createAction(`[${ActionPrefix}] Toast Reset`);
export const ToastError = createToastAction(ActionPrefix, 'Error', NotificationType.ERROR);
export const ToastWarning = createToastAction(ActionPrefix, 'Warning', NotificationType.WARNING);
export const ToastSuccess = createToastAction(ActionPrefix, 'Success', NotificationType.SUCCESS);

function createToastAction(actionPrefix: string, name: string, level: NotificationType) {
	return createAction(
		`[${actionPrefix}] Toast ${name}`,
		(message: string, options?: INotificationOptions, messageParams?: any) => ({
			message,
			messageParams,
			options,
			level
		})
	);
}

export const NavigateToGate = createAction(`[${ActionPrefix}] Navigate to gate`, props<{ path?: string }>());

export const OpenUrl = createAction(
	`[${ActionPrefix}] Open URL`,
	props<{ url: string, fileName: string, download?: boolean }>()
);

export const PrintUrl = createAction(`[${ActionPrefix}] Print URL`, props<{ url: string }>());

export const DownloadDocument = createAction(
	`[${ActionPrefix}] Download Document`,
	props<{ document: IDocumentFile, name?: string }>()
);

export const OpenDocument = createAction(`[${ActionPrefix}] Open Document`, props<{ document: IDocumentFile }>());
export const PreviewDocument = createAction(`[${ActionPrefix}] Preview Document`, props<{ document: IDocumentFile, title: string }>());
export const PrintDocument = createAction(`[${ActionPrefix}] Print Document`, props<{ document: IDocumentFile }>());
